var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xx-poi-select',_vm._g(_vm._b({attrs:{"size":_vm.size,"placeholder":"请选择DC","processData":_vm.processData,"selectItems":_vm.value},on:{"input":_vm.input}},'xx-poi-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }